import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Button, Spin } from 'antd';
import PropTypes from 'prop-types';

import { onEnterEstacio,
    estacioIntroduccioSeleccionarEstacio,
    estacioIntroduccioObtenirEstructura,
    estacioVisualitzacioObtenirEstacions } from '../../actions';

import EstacioTaula from './estacioTaula';
import errorBoundaryWrapper from '../commons/errorBoundaryWrapper';
import SpinnerBuitSempreActiu from '../commons/spinnerBuitSempreActiu';

import { selectorPeticioObtenirEstructuraEnCurs } from '../../selectors/selector_estacio_peticio_obtenir_estructura_en_curs';
import { selectorPeticioObtenirEstructuraIDadesEnCurs } from '../../selectors/selector_estacio_peticio_obtenir_estructura_i_dades_en_curs';

class Estacio extends Component {

    constructor(props) {
        super(props);
        this.renderitzarTaula = this.renderitzarTaula.bind(this);
    }

    componentWillMount() {
        this.props.onEnterEstacio();
    }

    componentDidMount() {
        this.props.estacioVisualitzacioObtenirEstacions();
    }

    renderitzarTaula() {
        const { estacions, estacioIntroduccioSeleccionarEstacio, router } = this.props;
        return (
            <EstacioTaula
                estacions={estacions}
                estacioIntroduccioSeleccionarEstacio={estacioIntroduccioSeleccionarEstacio}
                router={router}
            />
        );
    }

    render() {
        const {
            peticioEstacionsEnCurs,
            peticioObtenirEstructuraEnCurs,
            peticioObtenirEstructuraIDadesEnCurs,
            estacioIntroduccioObtenirEstructura,
            router
        } = this.props;

        const spinning = peticioObtenirEstructuraEnCurs || peticioObtenirEstructuraIDadesEnCurs;
        let textSpinning = '';
        if (peticioObtenirEstructuraEnCurs) textSpinning = 'Carregant introducció d\'estació';
        if (peticioObtenirEstructuraIDadesEnCurs) textSpinning = 'Carregant detall d\'estació';

        return (
            <div className='estacio'>
                <Spin className='estacio-spinner'
                    spinning={spinning}
                    tip={textSpinning}>
                    <div className='estacio-boto-inserir'>
                        <Button type='primary' icon='plus-circle-o' onClick={() => estacioIntroduccioObtenirEstructura(router)}>
                            Estació
                        </Button>
                    </div>
                    { peticioEstacionsEnCurs ? <SpinnerBuitSempreActiu /> : this.renderitzarTaula() }
                </Spin>
            </div>
        );
    }
}

Estacio.propTypes = {
    onEnterEstacio: PropTypes.func,
    estacions: PropTypes.object,
    peticioEstacionsEnCurs: PropTypes.bool,
    peticioObtenirEstructuraEnCurs: PropTypes.bool,
    peticioObtenirEstructuraIDadesEnCurs: PropTypes.bool,
    estacioVisualitzacioObtenirEstacions: PropTypes.func,
    estacioIntroduccioSeleccionarEstacio: PropTypes.func,
    estacioIntroduccioObtenirEstructura: PropTypes.func,
    router: PropTypes.object
};

const mapsStateToProps = (state) => {
    return {
        estacions: state.estacio.totes,
        peticioEstacionsEnCurs: state.estacio.peticioEstacionsEnCurs,
        peticioObtenirEstructuraEnCurs: selectorPeticioObtenirEstructuraEnCurs(state),
        peticioObtenirEstructuraIDadesEnCurs: selectorPeticioObtenirEstructuraIDadesEnCurs(state)
    };
};

const mapDispatchToProps = {
    onEnterEstacio,
    estacioIntroduccioSeleccionarEstacio,
    estacioIntroduccioObtenirEstructura,
    estacioVisualitzacioObtenirEstacions
};

export default errorBoundaryWrapper(connect(mapsStateToProps, mapDispatchToProps)(Estacio));



// WEBPACK FOOTER //
// ./src/components/estacio/estacio.js